export const isLoadingInsightsSelector = (state) =>
  state.newJob.insights.isLoading;
export const insightsSelector = (state) => state.newJob.insights.data;
